/**
 * FileUploader (frappe-ui) uses XMLHttpRequest for /api/method/upload_file.
 * Mirror fetch credentials + multitenant site header used by frappeFetchPatch.
 */
import { resolveSiteName } from './config'

const XHR = XMLHttpRequest.prototype
const originalOpen = XHR.open
const originalSend = XHR.send

XHR.open = function patchedOpen(
  method: string,
  url: string | URL,
  ...rest: unknown[]
): void {
  ;(this as XMLHttpRequest & { __frappeUrl?: string }).__frappeUrl = typeof url === 'string' ? url : String(url || '')
  return originalOpen.call(this, method, url, ...rest)
}

XHR.send = function patchedSend(body?: Document | BodyInit | null): void {
  const xhr = this as XMLHttpRequest & { __frappeUrl?: string }
  const url = xhr.__frappeUrl || ''
  if (url.includes('/api/')) {
    try {
      xhr.withCredentials = true
    } catch {
      /* ignore */
    }
    try {
      const site = resolveSiteName(window.site_name as string | undefined)
      if (site) {
        xhr.setRequestHeader('X-Frappe-Site-Name', site)
      }
    } catch {
      /* setRequestHeader may throw if already sent */
    }
  }
  return originalSend.call(this, body)
}